module.exports = __webpack_public_path__ + "static/uzoma_studio-7689ded4b8b81fa53e4d12d877e36aa8.jpg";